import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import {
  Alert,
  AlertIcon,
  Box,
  HStack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useWatch } from "react-hook-form";
import useCoversFile from "../../../hooks/covers/useFile";
import FormErrorObserverRHF from "../../ReactHookForm/FormErrorObserverRHF";
import ObserverRHF from "../../ReactHookForm/ObserverRHF";
import { IoCheckmarkOutline } from "react-icons/io5";
import ImagesTransformRHF from "../../Images/TransformRHF";

export default function CoversTransform(props) {
  const {
    transformationsName,
    coverName,
    circularCrop,
    variant,
    formats: _formats,
  } = props;

  const intl = useIntl();

  const file = useWatch({ name: coverName });

  const cover = useCoversFile(file);

  const formats = Object.entries(_formats);

  const hasMoreThanOneFormat = formats.length > 1;

  return (
    <Box>
      <VStack alignItems="stretch" spacing="1rem">
        <Alert status="info">
          <AlertIcon />

          {intl.formatMessage(
            {
              defaultMessage:
                "Déplacez et changez la taille de la zone en surbrillance pour recadrer l'image{hasMoreThanOneFormat, select, true {, pour chaque emplacement} other {}}.",
            },
            { hasMoreThanOneFormat },
          )}
        </Alert>

        {hasMoreThanOneFormat ? (
          <Tabs>
            <TabList>
              {formats.map(function ([formatName, format]) {
                return (
                  <FormErrorObserverRHF
                    key={formatName}
                    name={`${transformationsName}.${formatName}`}
                    render={({ hasError }) => {
                      return (
                        <Tab color={hasError ? "red.500" : undefined}>
                          <HStack spacing=".5rem">
                            <ObserverRHF
                              names={[`${transformationsName}.${formatName}`]}
                              render={({ values: [transformations] }) => {
                                const hasTransformations =
                                  Boolean(transformations);
                                return (
                                  <>
                                    {hasTransformations && !hasError && (
                                      <IoCheckmarkOutline />
                                    )}
                                  </>
                                );
                              }}
                            />

                            <Text>{format?.name ?? formatName}</Text>
                          </HStack>
                        </Tab>
                      );
                    }}
                  />
                );
              })}
            </TabList>

            <TabPanels>
              {formats.map(function ([formatName, format]) {
                return (
                  <TabPanel key={formatName} px="0">
                    <ImagesTransformRHF
                      image={cover}
                      variant={variant}
                      format={format}
                      circularCrop={circularCrop}
                      formatName={formatName}
                      transformationsName={transformationsName}
                    />
                  </TabPanel>
                );
              })}
            </TabPanels>
          </Tabs>
        ) : (
          <ImagesTransformRHF
            image={cover}
            variant={variant}
            format={formats[0][1]}
            circularCrop={circularCrop}
            formatName={formats[0][0]}
            transformationsName={transformationsName}
          />
        )}
      </VStack>
    </Box>
  );
}

CoversTransform.propTypes = {
  constraints: PropTypes.object,
  circularCrop: PropTypes.bool,
  formats: PropTypes.object,
  transformationsName: PropTypes.string,
  coverName: PropTypes.string,
  form: PropTypes.object,
  variant: PropTypes.oneOf(["tight", "expanded"]),
};

CoversTransform.defaultProps = {
  variant: "tight",
};
